import React from "react"
import Banner from "../components/Banner/Banner"
import CursorManager from "../components/CustomCursor/context/ContextManager"
import CustomCursor from "../components/CustomCursor/CustomCursor"
import Footer from "../components/Footer/Footer"
import Header from "../components/Header/Header"
import Projects from "../components/Project/Projects"
import Socials from "../components/Socials/Socials"
import Contact from "../components/Contact/Contact"
import { ThemeProvider } from "../components/ThemeButton/ThemeProvider"
import SEO from "../components/seo";
import "../styles/styles.scss"
import "../styles/styles.css"


const IndexPage = () => (
  <>
    <SEO title="Portfolio" />
    <div className="site-root">
        <ThemeProvider>
          <CursorManager>
            <CustomCursor/>
            <Header />
            <Socials />
            <Banner />
            <Projects />
            <Contact />
            <Footer />
          </CursorManager>
        </ThemeProvider>
    </div>
  </>
)

export default IndexPage
